import { Component, inject } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { PayeeIconComponent } from '../../payee-icon/payee-icon.component';
import { PayeeFormFieldComponent } from '../../payee-form-fields/payee-form-field/payee-form-field.component';
import { PayeeCopyFormFieldComponent } from '../../payee-form-fields/payee-copy-form-field/payee-copy-form-field.component';
import { PayeeButtonComponent } from '../../payee-buttons/payee-button/payee-button.component';
import { CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type BailiffDeliveryFeeTransferDialogData = {
  delivery_fee: {
    amount: number;
    currency_iso: string;
  };
  reference: string;
};

@Component({
  selector: 'app-bailiff-delivery-fee-transfer-dialog',
  templateUrl: './bailiff-delivery-fee-transfer-dialog.component.html',
  styleUrls: ['./bailiff-delivery-fee-transfer-dialog.component.scss'],
  imports: [
    PayeeIconComponent,
    FormsModule,
    ReactiveFormsModule,
    PayeeFormFieldComponent,
    PayeeCopyFormFieldComponent,
    PayeeButtonComponent,
    MatDialogClose,
    CurrencyPipe,
    TranslateModule,
  ],
})
export class BailiffDeliveryFeeTransferDialogComponent {
  private fb = inject(FormBuilder);
  data = inject<BailiffDeliveryFeeTransferDialogData>(MAT_DIALOG_DATA);

  readonly form = this.fb.group({
    transfer_amount: this.fb.control(this.data.delivery_fee.amount, {
      nonNullable: true,
    }),
    currency_iso: this.fb.control(this.data.delivery_fee.currency_iso, {
      nonNullable: true,
    }),
    account_holder_name: this.fb.control('Legal Labs Kft.', {
      nonNullable: true,
    }),
    account_number: this.fb.control('12600016-19259526-84463815', {
      nonNullable: true,
    }),
    reference: this.fb.control(this.data.reference, { nonNullable: true }),
  });
}
